import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import MediaBrowserService from '../mediaBrowser/MediaBrowserService.jsx';
import { valueForKeyPath as v } from '../../../../utils.jsx';

var AudioWidget = createReactClass({
  propTypes: {
    index: PropTypes.number,
    uuid: PropTypes.string,
    changeObject: PropTypes.func,
    contentSpace: PropTypes.string,
    data: PropTypes.object,
  },

  didRemoveWidget() {
    this.props.didRemoveWidget(this.props.index);
  },

  moveWidgetUp() {
    this.props.moveWidget(this.props.index, 'up');
  },

  moveWidgetDown() {
    this.props.moveWidget(this.props.index, 'down');
  },

  getDefaultProps: function() {
    return {
      index: 0,
      data: {
        uri: null,
        name: null,
        description: null,
      },
      uuid: '',
      changeObject: function() {},
    };
  },

  setFile: function(event) {
    var _this = this;
    var onFileSelect = function(uri, item) {
      MediaBrowserService.closeMediaBrowser();
      var object = _this.getWidgetObject();
      object.uri = uri;
      object.mediatype = v(item, 'type');
      _this.props.changeObject(_this.props.index, object);
    };
    MediaBrowserService.openMediaBrowser(
      onFileSelect,
      null,
      this.props.mediaManager,
      false,
    );
  },

  getWidgetObject: function() {
    return {
      type: 'audio',
      uri: this.props.data.uri,
      name: this.props.data.name,
      description: this.props.data.description,
      uuid: this.props.uuid,
      mediatype: this.props.type,
    };
  },

  onChange: function() {
    var o = this.getWidgetObject();
    o.name = this.refs.name.value;
    o.description = this.refs.description.value;
    this.props.changeObject(this.props.index, o);
  },

  render: function() {
    var contentHtml = null;
    if (!this.props.data.uri) {
      // ak nemame uri tak zobrazime plochu pre pridanie
      contentHtml = (
        <button onClick={this.setFile} className="btn btn-link btn-sm">
          Vybrať
        </button>
      );
    } else {
      // ak mame zadane uri tak zobrazime obrazok
      const audiourl = 'https://data.tvkosice.sk/cmdata/' + this.props.data.uri;
      const mediatype = v(this.props.data, 'mediatype');
      contentHtml = (
        <div>
          <a
            href={'https://data.tvkosice.sk/cmdata/' + this.props.data.uri}
            target="_blank"
          >
            <i className="fa fa-save" /> {mediatype}
          </a>{' '}
          &nbsp;
          <audio
            controls
            style={{ verticalAlign: 'middle' }}
            src={audiourl}
          />{' '}
          <button onClick={this.setFile} className="btn btn-link">
            Zmeniť
          </button>
        </div>
      );
    }
    return (
      <div
        data-index={this.props.index}
        style={{ clear: 'both' }}
        className="panel panel-default widget-body"
      >
        <div className="panel-heading">
          <div className="btn-group">
            <button
              className="btn btn-default btn-sm"
              onClick={this.moveWidgetUp}
              disabled={this.props.index === 0}
            >
              <i className="fa fa-arrow-up" />
            </button>
            <button
              className="btn btn-default btn-sm"
              onClick={this.moveWidgetDown}
              disabled={this.props.isLast}
            >
              <i className="fa fa-arrow-down" />
            </button>
          </div>
          <span className="panel-title">
            <strong> {this.props.name}</strong>
          </span>
          <a
            onClick={this.didRemoveWidget}
            href="javascript:void(0);"
            className="btn btn-danger btn-sm pull-right"
          >
            <i className="fa fa-times" />
          </a>
        </div>
        <div className="panel-body form-horizontal">
          <div className="form-group">
            <label className="title control-label col-sm-2">Názov</label>
            <div className="col-sm-10">
              <input
                onChange={this.onChange}
                value={this.props.data.name || ''}
                type="text"
                placeholder=""
                className="form-control"
                ref="name"
              />
            </div>
          </div>
          <div className="form-group">
            <label className="title control-label col-sm-2">Popis</label>
            <div className="col-sm-10">
              <input
                onChange={this.onChange}
                value={this.props.data.description || ''}
                type="text"
                placeholder=""
                className="form-control"
                ref="description"
              />
            </div>
          </div>
          <div className="form-group">
            <label className="title control-label col-sm-2">
              Zvukový súbor
            </label>
            <div className="col-sm-10">
              <div className="form-control-static">{contentHtml}</div>
            </div>
          </div>
        </div>
      </div>
    );
  },
});

export default AudioWidget;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/ArticleWidgets/ArticleAudioWidget.jsx